import React from 'react';
import { call, takeEvery } from 'redux-saga/effects';
import showToast from '@/utils/toasts';
import UpdatedToast from '@/components/toasts/UpdatedToast';
import actions from '../constants';

export function* updateRoleActionsToast({ role }) {
  yield call(showToast, <UpdatedToast code={role.code} name={role.name} />);
}

export default function* roleActionsToasts() {
  yield takeEvery(actions.UPDATE_ROLE_ACTIONS_SUCCESS, updateRoleActionsToast);
}
